import { useAPI } from "@/api/api";
import { IFEmpty } from "@/api/apiRsp/IFEmpty";
import { IFUserInfo } from "@/api/apiRsp/IFSigninRsp";

/**
 * 用戶信息
 */
export function useUserInfo() {
    const { data, error, revalidate, mutate } = useAPI<IFUserInfo, IFEmpty>(
        { path: 'api/member/info', type: 'post', needLogin: true }
        , {}, { revalidateOnMount: false});
    return {
        mutate,
        data,
        errorCode: error?.code,
        revalidate,
    };
}

